
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import AttributeService from "@/services/AttributeService";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Money } from 'v-money';
import Multiselect from "vue-multiselect";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import DateRangePicker from "vue2-daterange-picker";
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    Money,
    Multiselect,
    vSelect
  },
  computed: {
   ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class Attribute extends Vue {

  private attributeService = new AttributeService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private editing: boolean = false;
  private loadingModal: boolean = false;

  /**
   * @type Object
   * list returned from backend
   */
  private attributeListPlatform: any = [];
  private attributesList: any = [];
  private attributes: any = [];
  private selectedAtributes: any = [];
  private attributePlatform: any = [];

  /**
   * @type boolean
   */
  private loading: boolean = false;
  private nothingToAdd: boolean = false;

  /**
   * @tyoe Array
   * Define columns from datatables
     */
    private columnsAttributes = [
        { data: "id_lead_attribute", name: "id_lead_attribute", title: "ID", orderable: false, defaultContent: ""},
        { data: "name", name: "name", title: "Nome",orderable: true},
        { data: "Atributo",name: "Atributo", title: "Label",orderable: true},
        { data: "Descrição",name: "Descrição",title: "Descrição",orderable: true},
        { data: "label",name: "label",title: "Ativo",orderable: true},
        { data: "Tipo",name: "Tipo",title: "Tipo",orderable: false},
        { data: "date_created",name: "date_created",title: "Criado",orderable: true},
        { data: "updated_at",name: "updated_at",title: "Alterado",orderable: true}
    ];

  private attributePlatformFilds = [
    { key: 'Atributo', label: 'Label' },
    { key: 'name', label: 'Nome' },
    { key: 'Descrição', label: 'Descrição' },
    { key: 'Status', label: 'Status' },
    { key: 'Tipo', label: 'Tipo' },
    { key: '', label: '' },
  ];

  private attributeChanges:any = {
    ids_attributes: [],
    deleted_ids_attributes:[]
  }

  private get getNothingToAdd() {
    return this.nothingToAdd;
  }

  private addAttributeList(){
    this.nothingToAdd = false;
    const duplicatePlatformIndex = this.attributeListPlatform.findIndex(e => e.ID === this.attributes!.ID);
    console.log(duplicatePlatformIndex);

    if (duplicatePlatformIndex > 0){
        this.attributeListPlatform.splice(duplicatePlatformIndex, 1);
    }else if(!!this.attributes.ID){
        this.attributeChanges.ids_attributes.push(this.attributes.ID);
    }

    this.attributeListPlatform.push(this.attributes);
    this.attributes = null;
  }

   private async addAttribute() {
    this.loading = true;
    this.nothingToAdd = false;

    try {
        if(this.attributeChanges.ids_attributes.length > 0 && this.attributeChanges.ids_attributes.length > 0){
            await this.attributeService.store(this.$auth.user().id_platform, this.attributeChanges);
            this.$store.commit("navBarAlert/SUCCESS_ALERT", "Atributo salvo com sucesso");
        }else{
            this.loading = false;
            this.nothingToAdd = true;
            return this.$store.commit("navBarAlert/DANGER_ALERT", "Nada a Adicionar");
        }

        this.loading = false;
        this.hideModal('modal-add-attribute');
    } catch (error) {
        console.log(error);
        this.loading = false;
        this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao salvar atributo");
        this.hideModal('modal-add-attribute');
    }

    this.attributeChanges = {
        ids_attributes: [],
        deleted_ids_attributes:[]
    }
  }

  private closeAttributeModal(){

  }
  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;
    this.loading = true;

    try {
        this.attributeListPlatform = await this.attributeService.show(this.$auth.user().id_platform);
        this.attributesList = await this.attributeService.list();
    } catch (error) {
      console.log(error);
    }

    this.loading = false;
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }
}
